<div class="content">
  <ng-content></ng-content>
</div>

<div class="remove-btn" (click)="remove.emit()">
  <i class="icon icofont icofont-close"></i>
</div>
